import { useDispatch, useSelector } from 'react-redux';
import {
  getSongs,
  resetSongs,
  setSongListPosition,
} from 'services/store/songs/actions/actionCreators';
import type { SongsStore } from 'services/store/songs';
import { checkLoadingSelector } from 'services/store/base/selectors';
import songsActions from 'services/store/songs/actions/constants';
import {
  AppliedFiltersType,
  SelectedTagsType,
} from 'services/store/tags/types';
import type { BaseActionStore, StoreRootState } from 'services/store/types';

type UseSongsStore = {
  songsStore: SongsStore;
  isGetSongsLoading: boolean;
  getSongs: (params: {
    page: number;
    selectedTags?: SelectedTagsType;
    appliedFilters?: AppliedFiltersType;
  }) => void;
  resetSongs: () => void;
  saveScrollPosition: (pos: number) => void;
};

const useSongsStore = (): UseSongsStore => {
  const dispatch = useDispatch();
  const baseStore: BaseActionStore = useSelector(
    (store: StoreRootState) => store.base
  );
  const songsStore: SongsStore = useSelector(
    (store: StoreRootState) => store.songs
  );

  return {
    songsStore,
    isGetSongsLoading: checkLoadingSelector(baseStore, [
      songsActions.GET_SONGS,
    ]),
    getSongs: (params) => {
      const { page, selectedTags, appliedFilters } = params;
      dispatch(getSongs(page, selectedTags, appliedFilters));
    },
    resetSongs: (): void => {
      dispatch(resetSongs());
    },
    saveScrollPosition: (pos): void => {
      dispatch(setSongListPosition({ position: pos }));
    },
  };
};

export default useSongsStore;
